// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2SY-D","productName":"Table_productName__1n31M"};